import React, { useContext } from 'react'

import Link from 'next/link'
import PropTypes from 'prop-types'
import Dotdotdot from 'react-dotdotdot'
import UnmissableCardStyles from './unmissable-card-styles'
import ApiContext from '../../utils/api-context'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

const UnmissableCard = (props) => {
  // const classes = UnmissableCardStyles({})
  const { destination } = props
  const { t, i18n } = useTranslation()
  const router = useRouter()
  const { apiUrl, cdnUrl } = useContext(ApiContext)
  return (
    <div className={'unmissable-card'}>
      <div>
        <img
          src={`${destination.image.url}`}
          alt={destination[`title`]}
        />
      </div>
      <div className={'card-content'}>
        <h3>{destination[`title`]}</h3>
        <p>{destination[`intro`]}</p>
        <Link href={destination[`button_link`]} as={destination[`button_link`]}>
          {destination[`button_text`]}
        </Link>
      </div>
    </div>
  )
}
UnmissableCard.propTypes = {
  destination: PropTypes.any.isRequired,
}
export default UnmissableCard
